module.exports = __webpack_public_path__ + "img/banner.1dc2c1a0.png";